import { render, staticRenderFns } from "./attribute-calculation-config.vue?vue&type=template&id=0db866b8&"
import script from "./attribute-calculation-config.vue?vue&type=script&lang=js&"
export * from "./attribute-calculation-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports